// RAID item type badges (5 types — brief §19.2).
const RAID_TYPES = {
  risk:       { label: 'Risk',       short: 'R',   bg: '#FCEBEB', color: '#A32D2D' },
  assumption: { label: 'Assumption', short: 'A',   bg: '#FAEEDA', color: '#854F0B' },
  issue:      { label: 'Issue',      short: 'I',   bg: '#FCEBEB', color: '#A32D2D' },
  dependency: { label: 'Dependency', short: 'D',   bg: '#E6F1FB', color: '#0C447C' },
  decision:   { label: 'Decision',   short: 'Dec', bg: '#EEEDFE', color: '#3C3489' },
};

/**
 * Colour-coded badge for a RAID item type.
 * `short` renders the abbreviated form (R / A / I / D / Dec).
 */
export default function TypeBadge({ type, short = false }) {
  const t = RAID_TYPES[type] || { label: type, short: type, bg: '#f1efe8', color: '#5f5e5a' };
  return (
    <span style={{
      fontSize: 10, padding: '2px 7px', borderRadius: 5, fontWeight: 600,
      background: t.bg, color: t.color, whiteSpace: 'nowrap',
    }}>
      {short ? t.short : t.label}
    </span>
  );
}

export { RAID_TYPES };
